import { createContext } from 'react';
export const BulkEnrichmentContext = /*#__PURE__*/createContext(undefined);